// Generated from Python2.g4 by ANTLR 4.7.1
// jshint ignore: start
import antlr4 from 'antlr4/index';

import { Python2Parser } from './Python2Parser';
import { CommonToken } from 'antlr4';
class IndentStack {
    constructor() {
        this._s = [];
    }
    empty() {
        return this._s.length === 0;
    }
    push(wsval) {
        this._s.push(wsval);
    }
    pop() {
        this._s.pop();
    }
    wsval() {
        if (this._s.length) return this._s[this._s.length - 1];
        else return 0;
    }
}

class TokenQueue {
    constructor() {
        this._q = [];
    }
    empty() {
        return this._q.length === 0;
    }
    enq(t) {
        this._q.push(t);
    }
    deq() {
        return this._q.shift();
    }
}

function ord(char) {
    return char.charCodeAt();
}


var serializedATN = ["\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964",
    "\u0002T\u02b3\b\u0001\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004",
    "\u0004\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t",
    "\u0007\u0004\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004",
    "\f\t\f\u0004\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010",
    "\t\u0010\u0004\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013",
    "\u0004\u0014\t\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017",
    "\t\u0017\u0004\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a",
    "\u0004\u001b\t\u001b\u0004\u001c\t\u001c\u0004\u001d\t\u001d\u0004\u001e",
    "\t\u001e\u0004\u001f\t\u001f\u0004 \t \u0004!\t!\u0004\"\t\"\u0004#",
    "\t#\u0004$\t$\u0004%\t%\u0004&\t&\u0004\'\t\'\u0004(\t(\u0004)\t)\u0004",
    "*\t*\u0004+\t+\u0004,\t,\u0004-\t-\u0004.\t.\u0004/\t/\u00040\t0\u0004",
    "1\t1\u00042\t2\u00043\t3\u00044\t4\u00045\t5\u00046\t6\u00047\t7\u0004",
    "8\t8\u00049\t9\u0004:\t:\u0004;\t;\u0004<\t<\u0004=\t=\u0004>\t>\u0004",
    "?\t?\u0004@\t@\u0004A\tA\u0004B\tB\u0004C\tC\u0004D\tD\u0004E\tE\u0004",
    "F\tF\u0004G\tG\u0004H\tH\u0004I\tI\u0004J\tJ\u0004K\tK\u0004L\tL\u0004",
    "M\tM\u0004N\tN\u0004O\tO\u0004P\tP\u0004Q\tQ\u0004R\tR\u0004S\tS\u0003",
    "\u0002\u0003\u0002\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003",
    "\u0004\u0003\u0004\u0003\u0005\u0003\u0005\u0003\u0006\u0003\u0006\u0003",
    "\u0007\u0003\u0007\u0003\b\u0003\b\u0003\b\u0003\t\u0003\t\u0003\n\u0003",
    "\n\u0003\n\u0003\u000b\u0003\u000b\u0003\u000b\u0003\f\u0003\f\u0003",
    "\f\u0003\r\u0003\r\u0003\r\u0003\u000e\u0003\u000e\u0003\u000e\u0003",
    "\u000f\u0003\u000f\u0003\u000f\u0003\u0010\u0003\u0010\u0003\u0010\u0003",
    "\u0011\u0003\u0011\u0003\u0011\u0003\u0012\u0003\u0012\u0003\u0012\u0003",
    "\u0012\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0014\u0003",
    "\u0014\u0003\u0014\u0003\u0014\u0003\u0015\u0003\u0015\u0003\u0015\u0003",
    "\u0015\u0003\u0016\u0003\u0016\u0003\u0016\u0003\u0017\u0003\u0017\u0003",
    "\u0017\u0003\u0017\u0003\u0018\u0003\u0018\u0003\u0018\u0003\u0018\u0003",
    "\u0018\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003",
    "\u0019\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001a\u0003",
    "\u001a\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001b\u0003\u001b\u0003",
    "\u001b\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001c\u0003",
    "\u001c\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001d\u0003",
    "\u001d\u0003\u001d\u0003\u001d\u0003\u001d\u0003\u001d\u0003\u001d\u0003",
    "\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001f\u0003",
    "\u001f\u0003 \u0003 \u0003 \u0003!\u0003!\u0003!\u0003!\u0003!\u0003",
    "!\u0003!\u0003\"\u0003\"\u0003\"\u0003\"\u0003\"\u0003#\u0003#\u0003",
    "#\u0003$\u0003$\u0003$\u0003$\u0003$\u0003$\u0003$\u0003%\u0003%\u0003",
    "%\u0003&\u0003&\u0003&\u0003&\u0003&\u0003\'\u0003\'\u0003\'\u0003\'",
    "\u0003\'\u0003(\u0003(\u0003(\u0003(\u0003(\u0003(\u0003)\u0003)\u0003",
    ")\u0003)\u0003*\u0003*\u0003*\u0003*\u0003+\u0003+\u0003+\u0003+\u0003",
    "+\u0003+\u0003+\u0003+\u0003,\u0003,\u0003,\u0003,\u0003,\u0003-\u0003",
    "-\u0003-\u0003-\u0003-\u0003-\u0003-\u0003.\u0003.\u0003.\u0003.\u0003",
    ".\u0003.\u0003.\u0003/\u0003/\u0003/\u00030\u00030\u00030\u00030\u0003",
    "1\u00031\u00031\u00031\u00032\u00032\u00033\u00033\u00034\u00034\u0003",
    "4\u00035\u00035\u00035\u00036\u00036\u00036\u00037\u00037\u00037\u0003",
    "8\u00038\u00038\u00039\u00039\u00039\u0003:\u0003:\u0003;\u0003;\u0003",
    "<\u0003<\u0003=\u0003=\u0003=\u0003>\u0003>\u0003?\u0003?\u0003@\u0003",
    "@\u0003A\u0003A\u0003B\u0003B\u0003B\u0003C\u0003C\u0003D\u0003D\u0003",
    "E\u0003E\u0003E\u0003E\u0003E\u0003E\u0003F\u0003F\u0003F\u0003F\u0003",
    "F\u0003F\u0003G\u0003G\u0007G\u01af\nG\fG\u000eG\u01b2\u000bG\u0003",
    "H\u0003H\u0003H\u0006H\u01b7\nH\rH\u000eH\u01b8\u0003H\u0003H\u0003",
    "H\u0005H\u01be\nH\u0003H\u0006H\u01c1\nH\rH\u000eH\u01c2\u0005H\u01c5",
    "\nH\u0003H\u0003H\u0006H\u01c9\nH\rH\u000eH\u01ca\u0003H\u0005H\u01ce",
    "\nH\u0003H\u0003H\u0006H\u01d2\nH\rH\u000eH\u01d3\u0003H\u0005H\u01d7",
    "\nH\u0005H\u01d9\nH\u0003H\u0006H\u01dc\nH\rH\u000eH\u01dd\u0003H\u0003",
    "H\u0007H\u01e2\nH\fH\u000eH\u01e5\u000bH\u0003H\u0003H\u0006H\u01e9",
    "\nH\rH\u000eH\u01ea\u0005H\u01ed\nH\u0003H\u0003H\u0005H\u01f1\nH\u0003",
    "H\u0006H\u01f4\nH\rH\u000eH\u01f5\u0005H\u01f8\nH\u0003H\u0005H\u01fb",
    "\nH\u0003H\u0006H\u01fe\nH\rH\u000eH\u01ff\u0003H\u0003H\u0003H\u0005",
    "H\u0205\nH\u0003H\u0006H\u0208\nH\rH\u000eH\u0209\u0003H\u0005H\u020d",
    "\nH\u0003H\u0005H\u0210\nH\u0005H\u0212\nH\u0003I\u0005I\u0215\nI\u0003",
    "I\u0005I\u0218\nI\u0003I\u0005I\u021b\nI\u0003I\u0005I\u021e\nI\u0005",
    "I\u0220\nI\u0003I\u0003I\u0003I\u0006I\u0225\nI\rI\u000eI\u0226\u0003",
    "I\u0005I\u022a\nI\u0003I\u0005I\u022d\nI\u0003I\u0005I\u0230\nI\u0003",
    "I\u0007I\u0233\nI\fI\u000eI\u0236\u000bI\u0003I\u0003I\u0003I\u0003",
    "I\u0006I\u023c\nI\rI\u000eI\u023d\u0003I\u0005I\u0241\nI\u0003I\u0005",
    "I\u0244\nI\u0003I\u0005I\u0247\nI\u0003I\u0007I\u024a\nI\fI\u000eI\u024d",
    "\u000bI\u0003I\u0003I\u0003I\u0003I\u0003I\u0003I\u0003I\u0003I\u0007",
    "I\u0257\nI\fI\u000eI\u025a\u000bI\u0003I\u0003I\u0003I\u0003I\u0003",
    "I\u0003I\u0003I\u0003I\u0003I\u0003I\u0007I\u0266\nI\fI\u000eI\u0269",
    "\u000bI\u0003I\u0003I\u0003I\u0005I\u026e\nI\u0003J\u0005J\u0271\nJ",
    "\u0003J\u0006J\u0274\nJ\rJ\u000eJ\u0275\u0003J\u0003J\u0003J\u0007J",
    "\u027b\nJ\fJ\u000eJ\u027e\u000bJ\u0003J\u0005J\u0281\nJ\u0003J\u0003",
    "J\u0003J\u0005J\u0286\nJ\u0003J\u0003J\u0003J\u0003J\u0003K\u0006K\u028d",
    "\nK\rK\u000eK\u028e\u0003K\u0003K\u0003K\u0003K\u0003L\u0003L\u0007",
    "L\u0297\nL\fL\u000eL\u029a\u000bL\u0003L\u0003L\u0003M\u0003M\u0003",
    "M\u0003N\u0003N\u0003N\u0003O\u0003O\u0003O\u0003P\u0003P\u0003P\u0003",
    "Q\u0003Q\u0003Q\u0003R\u0003R\u0003R\u0003S\u0003S\u0003S\u0003S\u0004",
    "\u0258\u0267\u0002T\u0003\u0003\u0005\u0004\u0007\u0005\t\u0006\u000b",
    "\u0007\r\b\u000f\t\u0011\n\u0013\u000b\u0015\f\u0017\r\u0019\u000e\u001b",
    "\u000f\u001d\u0010\u001f\u0011!\u0012#\u0013%\u0014\'\u0015)\u0016+",
    "\u0017-\u0018/\u00191\u001a3\u001b5\u001c7\u001d9\u001e;\u001f= ?!A",
    "\"C#E$G%I&K\'M(O)Q*S+U,W-Y.[/]0_1a2c3e4g5i6k7m8o9q:s;u<w=y>{?}@\u007f",
    "A\u0081B\u0083C\u0085D\u0087E\u0089F\u008bG\u008dH\u008fI\u0091J\u0093",
    "K\u0095L\u0097M\u0099N\u009bO\u009dP\u009fQ\u00a1R\u00a3S\u00a5T\u0003",
    "\u0002\u0016\u0005\u0002C\\aac|\u0006\u00022;C\\aac|\u0004\u0002ZZz",
    "z\u0005\u00022;CHch\u0004\u0002NNnn\u0004\u0002GGgg\u0004\u0002--//",
    "\u0003\u00022;\u0004\u0002QQqq\u0003\u000229\u0004\u0002DDdd\u0003\u0002",
    "23\u0004\u0002LLll\u0006\u0002DDWWddww\u0004\u0002TTtt\u0004\u0002\u000b",
    "\u000b\"\"\u0006\u0002\f\f\u000f\u000f))^^\u0006\u0002\f\f\u000f\u000f",
    "$$^^\u0003\u0002^^\u0004\u0002\f\f\u000f\u000f\u0002\u02ee\u0002\u0003",
    "\u0003\u0002\u0002\u0002\u0002\u0005\u0003\u0002\u0002\u0002\u0002\u0007",
    "\u0003\u0002\u0002\u0002\u0002\t\u0003\u0002\u0002\u0002\u0002\u000b",
    "\u0003\u0002\u0002\u0002\u0002\r\u0003\u0002\u0002\u0002\u0002\u000f",
    "\u0003\u0002\u0002\u0002\u0002\u0011\u0003\u0002\u0002\u0002\u0002\u0013",
    "\u0003\u0002\u0002\u0002\u0002\u0015\u0003\u0002\u0002\u0002\u0002\u0017",
    "\u0003\u0002\u0002\u0002\u0002\u0019\u0003\u0002\u0002\u0002\u0002\u001b",
    "\u0003\u0002\u0002\u0002\u0002\u001d\u0003\u0002\u0002\u0002\u0002\u001f",
    "\u0003\u0002\u0002\u0002\u0002!\u0003\u0002\u0002\u0002\u0002#\u0003",
    "\u0002\u0002\u0002\u0002%\u0003\u0002\u0002\u0002\u0002\'\u0003\u0002",
    "\u0002\u0002\u0002)\u0003\u0002\u0002\u0002\u0002+\u0003\u0002\u0002",
    "\u0002\u0002-\u0003\u0002\u0002\u0002\u0002/\u0003\u0002\u0002\u0002",
    "\u00021\u0003\u0002\u0002\u0002\u00023\u0003\u0002\u0002\u0002\u0002",
    "5\u0003\u0002\u0002\u0002\u00027\u0003\u0002\u0002\u0002\u00029\u0003",
    "\u0002\u0002\u0002\u0002;\u0003\u0002\u0002\u0002\u0002=\u0003\u0002",
    "\u0002\u0002\u0002?\u0003\u0002\u0002\u0002\u0002A\u0003\u0002\u0002",
    "\u0002\u0002C\u0003\u0002\u0002\u0002\u0002E\u0003\u0002\u0002\u0002",
    "\u0002G\u0003\u0002\u0002\u0002\u0002I\u0003\u0002\u0002\u0002\u0002",
    "K\u0003\u0002\u0002\u0002\u0002M\u0003\u0002\u0002\u0002\u0002O\u0003",
    "\u0002\u0002\u0002\u0002Q\u0003\u0002\u0002\u0002\u0002S\u0003\u0002",
    "\u0002\u0002\u0002U\u0003\u0002\u0002\u0002\u0002W\u0003\u0002\u0002",
    "\u0002\u0002Y\u0003\u0002\u0002\u0002\u0002[\u0003\u0002\u0002\u0002",
    "\u0002]\u0003\u0002\u0002\u0002\u0002_\u0003\u0002\u0002\u0002\u0002",
    "a\u0003\u0002\u0002\u0002\u0002c\u0003\u0002\u0002\u0002\u0002e\u0003",
    "\u0002\u0002\u0002\u0002g\u0003\u0002\u0002\u0002\u0002i\u0003\u0002",
    "\u0002\u0002\u0002k\u0003\u0002\u0002\u0002\u0002m\u0003\u0002\u0002",
    "\u0002\u0002o\u0003\u0002\u0002\u0002\u0002q\u0003\u0002\u0002\u0002",
    "\u0002s\u0003\u0002\u0002\u0002\u0002u\u0003\u0002\u0002\u0002\u0002",
    "w\u0003\u0002\u0002\u0002\u0002y\u0003\u0002\u0002\u0002\u0002{\u0003",
    "\u0002\u0002\u0002\u0002}\u0003\u0002\u0002\u0002\u0002\u007f\u0003",
    "\u0002\u0002\u0002\u0002\u0081\u0003\u0002\u0002\u0002\u0002\u0083\u0003",
    "\u0002\u0002\u0002\u0002\u0085\u0003\u0002\u0002\u0002\u0002\u0087\u0003",
    "\u0002\u0002\u0002\u0002\u0089\u0003\u0002\u0002\u0002\u0002\u008b\u0003",
    "\u0002\u0002\u0002\u0002\u008d\u0003\u0002\u0002\u0002\u0002\u008f\u0003",
    "\u0002\u0002\u0002\u0002\u0091\u0003\u0002\u0002\u0002\u0002\u0093\u0003",
    "\u0002\u0002\u0002\u0002\u0095\u0003\u0002\u0002\u0002\u0002\u0097\u0003",
    "\u0002\u0002\u0002\u0002\u0099\u0003\u0002\u0002\u0002\u0002\u009b\u0003",
    "\u0002\u0002\u0002\u0002\u009d\u0003\u0002\u0002\u0002\u0002\u009f\u0003",
    "\u0002\u0002\u0002\u0002\u00a1\u0003\u0002\u0002\u0002\u0002\u00a3\u0003",
    "\u0002\u0002\u0002\u0002\u00a5\u0003\u0002\u0002\u0002\u0003\u00a7\u0003",
    "\u0002\u0002\u0002\u0005\u00a9\u0003\u0002\u0002\u0002\u0007\u00ad\u0003",
    "\u0002\u0002\u0002\t\u00af\u0003\u0002\u0002\u0002\u000b\u00b1\u0003",
    "\u0002\u0002\u0002\r\u00b3\u0003\u0002\u0002\u0002\u000f\u00b5\u0003",
    "\u0002\u0002\u0002\u0011\u00b8\u0003\u0002\u0002\u0002\u0013\u00ba\u0003",
    "\u0002\u0002\u0002\u0015\u00bd\u0003\u0002\u0002\u0002\u0017\u00c0\u0003",
    "\u0002\u0002\u0002\u0019\u00c3\u0003\u0002\u0002\u0002\u001b\u00c6\u0003",
    "\u0002\u0002\u0002\u001d\u00c9\u0003\u0002\u0002\u0002\u001f\u00cc\u0003",
    "\u0002\u0002\u0002!\u00cf\u0003\u0002\u0002\u0002#\u00d2\u0003\u0002",
    "\u0002\u0002%\u00d6\u0003\u0002\u0002\u0002\'\u00da\u0003\u0002\u0002",
    "\u0002)\u00de\u0003\u0002\u0002\u0002+\u00e2\u0003\u0002\u0002\u0002",
    "-\u00e5\u0003\u0002\u0002\u0002/\u00e9\u0003\u0002\u0002\u00021\u00ee",
    "\u0003\u0002\u0002\u00023\u00f4\u0003\u0002\u0002\u00025\u00fd\u0003",
    "\u0002\u0002\u00027\u0104\u0003\u0002\u0002\u00029\u010a\u0003\u0002",
    "\u0002\u0002;\u0111\u0003\u0002\u0002\u0002=\u0116\u0003\u0002\u0002",
    "\u0002?\u0118\u0003\u0002\u0002\u0002A\u011b\u0003\u0002\u0002\u0002",
    "C\u0122\u0003\u0002\u0002\u0002E\u0127\u0003\u0002\u0002\u0002G\u012a",
    "\u0003\u0002\u0002\u0002I\u0131\u0003\u0002\u0002\u0002K\u0134\u0003",
    "\u0002\u0002\u0002M\u0139\u0003\u0002\u0002\u0002O\u013e\u0003\u0002",
    "\u0002\u0002Q\u0144\u0003\u0002\u0002\u0002S\u0148\u0003\u0002\u0002",
    "\u0002U\u014c\u0003\u0002\u0002\u0002W\u0154\u0003\u0002\u0002\u0002",
    "Y\u0159\u0003\u0002\u0002\u0002[\u0160\u0003\u0002\u0002\u0002]\u0167",
    "\u0003\u0002\u0002\u0002_\u016a\u0003\u0002\u0002\u0002a\u016e\u0003",
    "\u0002\u0002\u0002c\u0172\u0003\u0002\u0002\u0002e\u0174\u0003\u0002",
    "\u0002\u0002g\u0176\u0003\u0002\u0002\u0002i\u0179\u0003\u0002\u0002",
    "\u0002k\u017c\u0003\u0002\u0002\u0002m\u017f\u0003\u0002\u0002\u0002",
    "o\u0182\u0003\u0002\u0002\u0002q\u0185\u0003\u0002\u0002\u0002s\u0188",
    "\u0003\u0002\u0002\u0002u\u018a\u0003\u0002\u0002\u0002w\u018c\u0003",
    "\u0002\u0002\u0002y\u018e\u0003\u0002\u0002\u0002{\u0191\u0003\u0002",
    "\u0002\u0002}\u0193\u0003\u0002\u0002\u0002\u007f\u0195\u0003\u0002",
    "\u0002\u0002\u0081\u0197\u0003\u0002\u0002\u0002\u0083\u0199\u0003\u0002",
    "\u0002\u0002\u0085\u019c\u0003\u0002\u0002\u0002\u0087\u019e\u0003\u0002",
    "\u0002\u0002\u0089\u01a0\u0003\u0002\u0002\u0002\u008b\u01a6\u0003\u0002",
    "\u0002\u0002\u008d\u01ac\u0003\u0002\u0002\u0002\u008f\u0211\u0003\u0002",
    "\u0002\u0002\u0091\u021f\u0003\u0002\u0002\u0002\u0093\u0285\u0003\u0002",
    "\u0002\u0002\u0095\u028c\u0003\u0002\u0002\u0002\u0097\u0294\u0003\u0002",
    "\u0002\u0002\u0099\u029d\u0003\u0002\u0002\u0002\u009b\u02a0\u0003\u0002",
    "\u0002\u0002\u009d\u02a3\u0003\u0002\u0002\u0002\u009f\u02a6\u0003\u0002",
    "\u0002\u0002\u00a1\u02a9\u0003\u0002\u0002\u0002\u00a3\u02ac\u0003\u0002",
    "\u0002\u0002\u00a5\u02af\u0003\u0002\u0002\u0002\u00a7\u00a8\u0007B",
    "\u0002\u0002\u00a8\u0004\u0003\u0002\u0002\u0002\u00a9\u00aa\u0007f",
    "\u0002\u0002\u00aa\u00ab\u0007g\u0002\u0002\u00ab\u00ac\u0007h\u0002",
    "\u0002\u00ac\u0006\u0003\u0002\u0002\u0002\u00ad\u00ae\u0007<\u0002",
    "\u0002\u00ae\b\u0003\u0002\u0002\u0002\u00af\u00b0\u0007?\u0002\u0002",
    "\u00b0\n\u0003\u0002\u0002\u0002\u00b1\u00b2\u0007.\u0002\u0002\u00b2",
    "\f\u0003\u0002\u0002\u0002\u00b3\u00b4\u0007,\u0002\u0002\u00b4\u000e",
    "\u0003\u0002\u0002\u0002\u00b5\u00b6\u0007,\u0002\u0002\u00b6\u00b7",
    "\u0007,\u0002\u0002\u00b7\u0010\u0003\u0002\u0002\u0002\u00b8\u00b9",
    "\u0007=\u0002\u0002\u00b9\u0012\u0003\u0002\u0002\u0002\u00ba\u00bb",
    "\u0007-\u0002\u0002\u00bb\u00bc\u0007?\u0002\u0002\u00bc\u0014\u0003",
    "\u0002\u0002\u0002\u00bd\u00be\u0007/\u0002\u0002\u00be\u00bf\u0007",
    "?\u0002\u0002\u00bf\u0016\u0003\u0002\u0002\u0002\u00c0\u00c1\u0007",
    ",\u0002\u0002\u00c1\u00c2\u0007?\u0002\u0002\u00c2\u0018\u0003\u0002",
    "\u0002\u0002\u00c3\u00c4\u00071\u0002\u0002\u00c4\u00c5\u0007?\u0002",
    "\u0002\u00c5\u001a\u0003\u0002\u0002\u0002\u00c6\u00c7\u0007\'\u0002",
    "\u0002\u00c7\u00c8\u0007?\u0002\u0002\u00c8\u001c\u0003\u0002\u0002",
    "\u0002\u00c9\u00ca\u0007(\u0002\u0002\u00ca\u00cb\u0007?\u0002\u0002",
    "\u00cb\u001e\u0003\u0002\u0002\u0002\u00cc\u00cd\u0007~\u0002\u0002",
    "\u00cd\u00ce\u0007?\u0002\u0002\u00ce \u0003\u0002\u0002\u0002\u00cf",
    "\u00d0\u0007`\u0002\u0002\u00d0\u00d1\u0007?\u0002\u0002\u00d1\"\u0003",
    "\u0002\u0002\u0002\u00d2\u00d3\u0007>\u0002\u0002\u00d3\u00d4\u0007",
    ">\u0002\u0002\u00d4\u00d5\u0007?\u0002\u0002\u00d5$\u0003\u0002\u0002",
    "\u0002\u00d6\u00d7\u0007@\u0002\u0002\u00d7\u00d8\u0007@\u0002\u0002",
    "\u00d8\u00d9\u0007?\u0002\u0002\u00d9&\u0003\u0002\u0002\u0002\u00da",
    "\u00db\u0007,\u0002\u0002\u00db\u00dc\u0007,\u0002\u0002\u00dc\u00dd",
    "\u0007?\u0002\u0002\u00dd(\u0003\u0002\u0002\u0002\u00de\u00df\u0007",
    "1\u0002\u0002\u00df\u00e0\u00071\u0002\u0002\u00e0\u00e1\u0007?\u0002",
    "\u0002\u00e1*\u0003\u0002\u0002\u0002\u00e2\u00e3\u0007@\u0002\u0002",
    "\u00e3\u00e4\u0007@\u0002\u0002\u00e4,\u0003\u0002\u0002\u0002\u00e5",
    "\u00e6\u0007f\u0002\u0002\u00e6\u00e7\u0007g\u0002\u0002\u00e7\u00e8",
    "\u0007n\u0002\u0002\u00e8.\u0003\u0002\u0002\u0002\u00e9\u00ea\u0007",
    "r\u0002\u0002\u00ea\u00eb\u0007c\u0002\u0002\u00eb\u00ec\u0007u\u0002",
    "\u0002\u00ec\u00ed\u0007u\u0002\u0002\u00ed0\u0003\u0002\u0002\u0002",
    "\u00ee\u00ef\u0007d\u0002\u0002\u00ef\u00f0\u0007t\u0002\u0002\u00f0",
    "\u00f1\u0007g\u0002\u0002\u00f1\u00f2\u0007c\u0002\u0002\u00f2\u00f3",
    "\u0007m\u0002\u0002\u00f32\u0003\u0002\u0002\u0002\u00f4\u00f5\u0007",
    "e\u0002\u0002\u00f5\u00f6\u0007q\u0002\u0002\u00f6\u00f7\u0007p\u0002",
    "\u0002\u00f7\u00f8\u0007v\u0002\u0002\u00f8\u00f9\u0007k\u0002\u0002",
    "\u00f9\u00fa\u0007p\u0002\u0002\u00fa\u00fb\u0007w\u0002\u0002\u00fb",
    "\u00fc\u0007g\u0002\u0002\u00fc4\u0003\u0002\u0002\u0002\u00fd\u00fe",
    "\u0007t\u0002\u0002\u00fe\u00ff\u0007g\u0002\u0002\u00ff\u0100\u0007",
    "v\u0002\u0002\u0100\u0101\u0007w\u0002\u0002\u0101\u0102\u0007t\u0002",
    "\u0002\u0102\u0103\u0007p\u0002\u0002\u01036\u0003\u0002\u0002\u0002",
    "\u0104\u0105\u0007t\u0002\u0002\u0105\u0106\u0007c\u0002\u0002\u0106",
    "\u0107\u0007k\u0002\u0002\u0107\u0108\u0007u\u0002\u0002\u0108\u0109",
    "\u0007g\u0002\u0002\u01098\u0003\u0002\u0002\u0002\u010a\u010b\u0007",
    "k\u0002\u0002\u010b\u010c\u0007o\u0002\u0002\u010c\u010d\u0007r\u0002",
    "\u0002\u010d\u010e\u0007q\u0002\u0002\u010e\u010f\u0007t\u0002\u0002",
    "\u010f\u0110\u0007v\u0002\u0002\u0110:\u0003\u0002\u0002\u0002\u0111",
    "\u0112\u0007h\u0002\u0002\u0112\u0113\u0007t\u0002\u0002\u0113\u0114",
    "\u0007q\u0002\u0002\u0114\u0115\u0007o\u0002\u0002\u0115<\u0003\u0002",
    "\u0002\u0002\u0116\u0117\u00070\u0002\u0002\u0117>\u0003\u0002\u0002",
    "\u0002\u0118\u0119\u0007c\u0002\u0002\u0119\u011a\u0007u\u0002\u0002",
    "\u011a@\u0003\u0002\u0002\u0002\u011b\u011c\u0007i\u0002\u0002\u011c",
    "\u011d\u0007n\u0002\u0002\u011d\u011e\u0007q\u0002\u0002\u011e\u011f",
    "\u0007d\u0002\u0002\u011f\u0120\u0007c\u0002\u0002\u0120\u0121\u0007",
    "n\u0002\u0002\u0121B\u0003\u0002\u0002\u0002\u0122\u0123\u0007g\u0002",
    "\u0002\u0123\u0124\u0007z\u0002\u0002\u0124\u0125\u0007g\u0002\u0002",
    "\u0125\u0126\u0007e\u0002\u0002\u0126D\u0003\u0002\u0002\u0002\u0127",
    "\u0128\u0007k\u0002\u0002\u0128\u0129\u0007p\u0002\u0002\u0129F\u0003",
    "\u0002\u0002\u0002\u012a\u012b\u0007c\u0002\u0002\u012b\u012c\u0007",
    "u\u0002\u0002\u012c\u012d\u0007u\u0002\u0002\u012d\u012e\u0007g\u0002",
    "\u0002\u012e\u012f\u0007t\u0002\u0002\u012f\u0130\u0007v\u0002\u0002",
    "\u0130H\u0003\u0002\u0002\u0002\u0131\u0132\u0007k\u0002\u0002\u0132",
    "\u0133\u0007h\u0002\u0002\u0133J\u0003\u0002\u0002\u0002\u0134\u0135",
    "\u0007g\u0002\u0002\u0135\u0136\u0007n\u0002\u0002\u0136\u0137\u0007",
    "k\u0002\u0002\u0137\u0138\u0007h\u0002\u0002\u0138L\u0003\u0002\u0002",
    "\u0002\u0139\u013a\u0007g\u0002\u0002\u013a\u013b\u0007n\u0002\u0002",
    "\u013b\u013c\u0007u\u0002\u0002\u013c\u013d\u0007g\u0002\u0002\u013d",
    "N\u0003\u0002\u0002\u0002\u013e\u013f\u0007y\u0002\u0002\u013f\u0140",
    "\u0007j\u0002\u0002\u0140\u0141\u0007k\u0002\u0002\u0141\u0142\u0007",
    "n\u0002\u0002\u0142\u0143\u0007g\u0002\u0002\u0143P\u0003\u0002\u0002",
    "\u0002\u0144\u0145\u0007h\u0002\u0002\u0145\u0146\u0007q\u0002\u0002",
    "\u0146\u0147\u0007t\u0002\u0002\u0147R\u0003\u0002\u0002\u0002\u0148",
    "\u0149\u0007v\u0002\u0002\u0149\u014a\u0007t\u0002\u0002\u014a\u014b",
    "\u0007{\u0002\u0002\u014bT\u0003\u0002\u0002\u0002\u014c\u014d\u0007",
    "h\u0002\u0002\u014d\u014e\u0007k\u0002\u0002\u014e\u014f\u0007p\u0002",
    "\u0002\u014f\u0150\u0007c\u0002\u0002\u0150\u0151\u0007n\u0002\u0002",
    "\u0151\u0152\u0007n\u0002\u0002\u0152\u0153\u0007{\u0002\u0002\u0153",
    "V\u0003\u0002\u0002\u0002\u0154\u0155\u0007y\u0002\u0002\u0155\u0156",
    "\u0007k\u0002\u0002\u0156\u0157\u0007v\u0002\u0002\u0157\u0158\u0007",
    "j\u0002\u0002\u0158X\u0003\u0002\u0002\u0002\u0159\u015a\u0007g\u0002",
    "\u0002\u015a\u015b\u0007z\u0002\u0002\u015b\u015c\u0007e\u0002\u0002",
    "\u015c\u015d\u0007g\u0002\u0002\u015d\u015e\u0007r\u0002\u0002\u015e",
    "\u015f\u0007v\u0002\u0002\u015fZ\u0003\u0002\u0002\u0002\u0160\u0161",
    "\u0007n\u0002\u0002\u0161\u0162\u0007c\u0002\u0002\u0162\u0163\u0007",
    "o\u0002\u0002\u0163\u0164\u0007d\u0002\u0002\u0164\u0165\u0007f\u0002",
    "\u0002\u0165\u0166\u0007c\u0002\u0002\u0166\\\u0003\u0002\u0002\u0002",
    "\u0167\u0168\u0007q\u0002\u0002\u0168\u0169\u0007t\u0002\u0002\u0169",
    "^\u0003\u0002\u0002\u0002\u016a\u016b\u0007c\u0002\u0002\u016b\u016c",
    "\u0007p\u0002\u0002\u016c\u016d\u0007f\u0002\u0002\u016d`\u0003\u0002",
    "\u0002\u0002\u016e\u016f\u0007p\u0002\u0002\u016f\u0170\u0007q\u0002",
    "\u0002\u0170\u0171\u0007v\u0002\u0002\u0171b\u0003\u0002\u0002\u0002",
    "\u0172\u0173\u0007>\u0002\u0002\u0173d\u0003\u0002\u0002\u0002\u0174",
    "\u0175\u0007@\u0002\u0002\u0175f\u0003\u0002\u0002\u0002\u0176\u0177",
    "\u0007?\u0002\u0002\u0177\u0178\u0007?\u0002\u0002\u0178h\u0003\u0002",
    "\u0002\u0002\u0179\u017a\u0007@\u0002\u0002\u017a\u017b\u0007?\u0002",
    "\u0002\u017bj\u0003\u0002\u0002\u0002\u017c\u017d\u0007>\u0002\u0002",
    "\u017d\u017e\u0007?\u0002\u0002\u017el\u0003\u0002\u0002\u0002\u017f",
    "\u0180\u0007>\u0002\u0002\u0180\u0181\u0007@\u0002\u0002\u0181n\u0003",
    "\u0002\u0002\u0002\u0182\u0183\u0007#\u0002\u0002\u0183\u0184\u0007",
    "?\u0002\u0002\u0184p\u0003\u0002\u0002\u0002\u0185\u0186\u0007k\u0002",
    "\u0002\u0186\u0187\u0007u\u0002\u0002\u0187r\u0003\u0002\u0002\u0002",
    "\u0188\u0189\u0007~\u0002\u0002\u0189t\u0003\u0002\u0002\u0002\u018a",
    "\u018b\u0007`\u0002\u0002\u018bv\u0003\u0002\u0002\u0002\u018c\u018d",
    "\u0007(\u0002\u0002\u018dx\u0003\u0002\u0002\u0002\u018e\u018f\u0007",
    ">\u0002\u0002\u018f\u0190\u0007>\u0002\u0002\u0190z\u0003\u0002\u0002",
    "\u0002\u0191\u0192\u0007-\u0002\u0002\u0192|\u0003\u0002\u0002\u0002",
    "\u0193\u0194\u0007/\u0002\u0002\u0194~\u0003\u0002\u0002\u0002\u0195",
    "\u0196\u00071\u0002\u0002\u0196\u0080\u0003\u0002\u0002\u0002\u0197",
    "\u0198\u0007\'\u0002\u0002\u0198\u0082\u0003\u0002\u0002\u0002\u0199",
    "\u019a\u00071\u0002\u0002\u019a\u019b\u00071\u0002\u0002\u019b\u0084",
    "\u0003\u0002\u0002\u0002\u019c\u019d\u0007\u0080\u0002\u0002\u019d\u0086",
    "\u0003\u0002\u0002\u0002\u019e\u019f\u0007b\u0002\u0002\u019f\u0088",
    "\u0003\u0002\u0002\u0002\u01a0\u01a1\u0007e\u0002\u0002\u01a1\u01a2",
    "\u0007n\u0002\u0002\u01a2\u01a3\u0007c\u0002\u0002\u01a3\u01a4\u0007",
    "u\u0002\u0002\u01a4\u01a5\u0007u\u0002\u0002\u01a5\u008a\u0003\u0002",
    "\u0002\u0002\u01a6\u01a7\u0007{\u0002\u0002\u01a7\u01a8\u0007k\u0002",
    "\u0002\u01a8\u01a9\u0007g\u0002\u0002\u01a9\u01aa\u0007n\u0002\u0002",
    "\u01aa\u01ab\u0007f\u0002\u0002\u01ab\u008c\u0003\u0002\u0002\u0002",
    "\u01ac\u01b0\t\u0002\u0002\u0002\u01ad\u01af\t\u0003\u0002\u0002\u01ae",
    "\u01ad\u0003\u0002\u0002\u0002\u01af\u01b2\u0003\u0002\u0002\u0002\u01b0",
    "\u01ae\u0003\u0002\u0002\u0002\u01b0\u01b1\u0003\u0002\u0002\u0002\u01b1",
    "\u008e\u0003\u0002\u0002\u0002\u01b2\u01b0\u0003\u0002\u0002\u0002\u01b3",
    "\u01d8\u00072\u0002\u0002\u01b4\u01b6\t\u0004\u0002\u0002\u01b5\u01b7",
    "\t\u0005\u0002\u0002\u01b6\u01b5\u0003\u0002\u0002\u0002\u01b7\u01b8",
    "\u0003\u0002\u0002\u0002\u01b8\u01b6\u0003\u0002\u0002\u0002\u01b8\u01b9",
    "\u0003\u0002\u0002\u0002\u01b9\u01c4\u0003\u0002\u0002\u0002\u01ba\u01c5",
    "\t\u0006\u0002\u0002\u01bb\u01bd\t\u0007\u0002\u0002\u01bc\u01be\t\b",
    "\u0002\u0002\u01bd\u01bc\u0003\u0002\u0002\u0002\u01bd\u01be\u0003\u0002",
    "\u0002\u0002\u01be\u01c0\u0003\u0002\u0002\u0002\u01bf\u01c1\t\t\u0002",
    "\u0002\u01c0\u01bf\u0003\u0002\u0002\u0002\u01c1\u01c2\u0003\u0002\u0002",
    "\u0002\u01c2\u01c0\u0003\u0002\u0002\u0002\u01c2\u01c3\u0003\u0002\u0002",
    "\u0002\u01c3\u01c5\u0003\u0002\u0002\u0002\u01c4\u01ba\u0003\u0002\u0002",
    "\u0002\u01c4\u01bb\u0003\u0002\u0002\u0002\u01c4\u01c5\u0003\u0002\u0002",
    "\u0002\u01c5\u01d9\u0003\u0002\u0002\u0002\u01c6\u01c8\t\n\u0002\u0002",
    "\u01c7\u01c9\t\u000b\u0002\u0002\u01c8\u01c7\u0003\u0002\u0002\u0002",
    "\u01c9\u01ca\u0003\u0002\u0002\u0002\u01ca\u01c8\u0003\u0002\u0002\u0002",
    "\u01ca\u01cb\u0003\u0002\u0002\u0002\u01cb\u01cd\u0003\u0002\u0002\u0002",
    "\u01cc\u01ce\t\u0006\u0002\u0002\u01cd\u01cc\u0003\u0002\u0002\u0002",
    "\u01cd\u01ce\u0003\u0002\u0002\u0002\u01ce\u01d9\u0003\u0002\u0002\u0002",
    "\u01cf\u01d1\t\f\u0002\u0002\u01d0\u01d2\t\r\u0002\u0002\u01d1\u01d0",
    "\u0003\u0002\u0002\u0002\u01d2\u01d3\u0003\u0002\u0002\u0002\u01d3\u01d1",
    "\u0003\u0002\u0002\u0002\u01d3\u01d4\u0003\u0002\u0002\u0002\u01d4\u01d6",
    "\u0003\u0002\u0002\u0002\u01d5\u01d7\t\u0006\u0002\u0002\u01d6\u01d5",
    "\u0003\u0002\u0002\u0002\u01d6\u01d7\u0003\u0002\u0002\u0002\u01d7\u01d9",
    "\u0003\u0002\u0002\u0002\u01d8\u01b4\u0003\u0002\u0002\u0002\u01d8\u01c6",
    "\u0003\u0002\u0002\u0002\u01d8\u01cf\u0003\u0002\u0002\u0002\u01d9\u0212",
    "\u0003\u0002\u0002\u0002\u01da\u01dc\t\t\u0002\u0002\u01db\u01da\u0003",
    "\u0002\u0002\u0002\u01dc\u01dd\u0003\u0002\u0002\u0002\u01dd\u01db\u0003",
    "\u0002\u0002\u0002\u01dd\u01de\u0003\u0002\u0002\u0002\u01de\u01df\u0003",
    "\u0002\u0002\u0002\u01df\u01e3\u00070\u0002\u0002\u01e0\u01e2\t\t\u0002",
    "\u0002\u01e1\u01e0\u0003\u0002\u0002\u0002\u01e2\u01e5\u0003\u0002\u0002",
    "\u0002\u01e3\u01e1\u0003\u0002\u0002\u0002\u01e3\u01e4\u0003\u0002\u0002",
    "\u0002\u01e4\u01ed\u0003\u0002\u0002\u0002\u01e5\u01e3\u0003\u0002\u0002",
    "\u0002\u01e6\u01e8\u00070\u0002\u0002\u01e7\u01e9\t\t\u0002\u0002\u01e8",
    "\u01e7\u0003\u0002\u0002\u0002\u01e9\u01ea\u0003\u0002\u0002\u0002\u01ea",
    "\u01e8\u0003\u0002\u0002\u0002\u01ea\u01eb\u0003\u0002\u0002\u0002\u01eb",
    "\u01ed\u0003\u0002\u0002\u0002\u01ec\u01db\u0003\u0002\u0002\u0002\u01ec",
    "\u01e6\u0003\u0002\u0002\u0002\u01ed\u01f7\u0003\u0002\u0002\u0002\u01ee",
    "\u01f0\t\u0007\u0002\u0002\u01ef\u01f1\t\b\u0002\u0002\u01f0\u01ef\u0003",
    "\u0002\u0002\u0002\u01f0\u01f1\u0003\u0002\u0002\u0002\u01f1\u01f3\u0003",
    "\u0002\u0002\u0002\u01f2\u01f4\t\t\u0002\u0002\u01f3\u01f2\u0003\u0002",
    "\u0002\u0002\u01f4\u01f5\u0003\u0002\u0002\u0002\u01f5\u01f3\u0003\u0002",
    "\u0002\u0002\u01f5\u01f6\u0003\u0002\u0002\u0002\u01f6\u01f8\u0003\u0002",
    "\u0002\u0002\u01f7\u01ee\u0003\u0002\u0002\u0002\u01f7\u01f8\u0003\u0002",
    "\u0002\u0002\u01f8\u01fa\u0003\u0002\u0002\u0002\u01f9\u01fb\t\u000e",
    "\u0002\u0002\u01fa\u01f9\u0003\u0002\u0002\u0002\u01fa\u01fb\u0003\u0002",
    "\u0002\u0002\u01fb\u0212\u0003\u0002\u0002\u0002\u01fc\u01fe\t\t\u0002",
    "\u0002\u01fd\u01fc\u0003\u0002\u0002\u0002\u01fe\u01ff\u0003\u0002\u0002",
    "\u0002\u01ff\u01fd\u0003\u0002\u0002\u0002\u01ff\u0200\u0003\u0002\u0002",
    "\u0002\u0200\u020f\u0003\u0002\u0002\u0002\u0201\u0210\t\u0006\u0002",
    "\u0002\u0202\u0204\t\u0007\u0002\u0002\u0203\u0205\t\b\u0002\u0002\u0204",
    "\u0203\u0003\u0002\u0002\u0002\u0204\u0205\u0003\u0002\u0002\u0002\u0205",
    "\u0207\u0003\u0002\u0002\u0002\u0206\u0208\t\t\u0002\u0002\u0207\u0206",
    "\u0003\u0002\u0002\u0002\u0208\u0209\u0003\u0002\u0002\u0002\u0209\u0207",
    "\u0003\u0002\u0002\u0002\u0209\u020a\u0003\u0002\u0002\u0002\u020a\u020c",
    "\u0003\u0002\u0002\u0002\u020b\u020d\t\u000e\u0002\u0002\u020c\u020b",
    "\u0003\u0002\u0002\u0002\u020c\u020d\u0003\u0002\u0002\u0002\u020d\u0210",
    "\u0003\u0002\u0002\u0002\u020e\u0210\t\u000e\u0002\u0002\u020f\u0201",
    "\u0003\u0002\u0002\u0002\u020f\u0202\u0003\u0002\u0002\u0002\u020f\u020e",
    "\u0003\u0002\u0002\u0002\u020f\u0210\u0003\u0002\u0002\u0002\u0210\u0212",
    "\u0003\u0002\u0002\u0002\u0211\u01b3\u0003\u0002\u0002\u0002\u0211\u01ec",
    "\u0003\u0002\u0002\u0002\u0211\u01fd\u0003\u0002\u0002\u0002\u0212\u0090",
    "\u0003\u0002\u0002\u0002\u0213\u0215\t\u000f\u0002\u0002\u0214\u0213",
    "\u0003\u0002\u0002\u0002\u0214\u0215\u0003\u0002\u0002\u0002\u0215\u0217",
    "\u0003\u0002\u0002\u0002\u0216\u0218\t\u0010\u0002\u0002\u0217\u0216",
    "\u0003\u0002\u0002\u0002\u0217\u0218\u0003\u0002\u0002\u0002\u0218\u0220",
    "\u0003\u0002\u0002\u0002\u0219\u021b\t\u0010\u0002\u0002\u021a\u0219",
    "\u0003\u0002\u0002\u0002\u021a\u021b\u0003\u0002\u0002\u0002\u021b\u021d",
    "\u0003\u0002\u0002\u0002\u021c\u021e\t\u000f\u0002\u0002\u021d\u021c",
    "\u0003\u0002\u0002\u0002\u021d\u021e\u0003\u0002\u0002\u0002\u021e\u0220",
    "\u0003\u0002\u0002\u0002\u021f\u0214\u0003\u0002\u0002\u0002\u021f\u021a",
    "\u0003\u0002\u0002\u0002\u0220\u026d\u0003\u0002\u0002\u0002\u0221\u0234",
    "\u0007)\u0002\u0002\u0222\u022f\u0007^\u0002\u0002\u0223\u0225\t\u0011",
    "\u0002\u0002\u0224\u0223\u0003\u0002\u0002\u0002\u0225\u0226\u0003\u0002",
    "\u0002\u0002\u0226\u0224\u0003\u0002\u0002\u0002\u0226\u0227\u0003\u0002",
    "\u0002\u0002\u0227\u022c\u0003\u0002\u0002\u0002\u0228\u022a\u0007\u000f",
    "\u0002\u0002\u0229\u0228\u0003\u0002\u0002\u0002\u0229\u022a\u0003\u0002",
    "\u0002\u0002\u022a\u022b\u0003\u0002\u0002\u0002\u022b\u022d\u0007\f",
    "\u0002\u0002\u022c\u0229\u0003\u0002\u0002\u0002\u022c\u022d\u0003\u0002",
    "\u0002\u0002\u022d\u0230\u0003\u0002\u0002\u0002\u022e\u0230\u000b\u0002",
    "\u0002\u0002\u022f\u0224\u0003\u0002\u0002\u0002\u022f\u022e\u0003\u0002",
    "\u0002\u0002\u0230\u0233\u0003\u0002\u0002\u0002\u0231\u0233\n\u0012",
    "\u0002\u0002\u0232\u0222\u0003\u0002\u0002\u0002\u0232\u0231\u0003\u0002",
    "\u0002\u0002\u0233\u0236\u0003\u0002\u0002\u0002\u0234\u0232\u0003\u0002",
    "\u0002\u0002\u0234\u0235\u0003\u0002\u0002\u0002\u0235\u0237\u0003\u0002",
    "\u0002\u0002\u0236\u0234\u0003\u0002\u0002\u0002\u0237\u026e\u0007)",
    "\u0002\u0002\u0238\u024b\u0007$\u0002\u0002\u0239\u0246\u0007^\u0002",
    "\u0002\u023a\u023c\t\u0011\u0002\u0002\u023b\u023a\u0003\u0002\u0002",
    "\u0002\u023c\u023d\u0003\u0002\u0002\u0002\u023d\u023b\u0003\u0002\u0002",
    "\u0002\u023d\u023e\u0003\u0002\u0002\u0002\u023e\u0243\u0003\u0002\u0002",
    "\u0002\u023f\u0241\u0007\u000f\u0002\u0002\u0240\u023f\u0003\u0002\u0002",
    "\u0002\u0240\u0241\u0003\u0002\u0002\u0002\u0241\u0242\u0003\u0002\u0002",
    "\u0002\u0242\u0244\u0007\f\u0002\u0002\u0243\u0240\u0003\u0002\u0002",
    "\u0002\u0243\u0244\u0003\u0002\u0002\u0002\u0244\u0247\u0003\u0002\u0002",
    "\u0002\u0245\u0247\u000b\u0002\u0002\u0002\u0246\u023b\u0003\u0002\u0002",
    "\u0002\u0246\u0245\u0003\u0002\u0002\u0002\u0247\u024a\u0003\u0002\u0002",
    "\u0002\u0248\u024a\n\u0013\u0002\u0002\u0249\u0239\u0003\u0002\u0002",
    "\u0002\u0249\u0248\u0003\u0002\u0002\u0002\u024a\u024d\u0003\u0002\u0002",
    "\u0002\u024b\u0249\u0003\u0002\u0002\u0002\u024b\u024c\u0003\u0002\u0002",
    "\u0002\u024c\u024e\u0003\u0002\u0002\u0002\u024d\u024b\u0003\u0002\u0002",
    "\u0002\u024e\u026e\u0007$\u0002\u0002\u024f\u0250\u0007$\u0002\u0002",
    "\u0250\u0251\u0007$\u0002\u0002\u0251\u0252\u0007$\u0002\u0002\u0252",
    "\u0258\u0003\u0002\u0002\u0002\u0253\u0254\u0007^\u0002\u0002\u0254",
    "\u0257\u000b\u0002\u0002\u0002\u0255\u0257\n\u0014\u0002\u0002\u0256",
    "\u0253\u0003\u0002\u0002\u0002\u0256\u0255\u0003\u0002\u0002\u0002\u0257",
    "\u025a\u0003\u0002\u0002\u0002\u0258\u0259\u0003\u0002\u0002\u0002\u0258",
    "\u0256\u0003\u0002\u0002\u0002\u0259\u025b\u0003\u0002\u0002\u0002\u025a",
    "\u0258\u0003\u0002\u0002\u0002\u025b\u025c\u0007$\u0002\u0002\u025c",
    "\u025d\u0007$\u0002\u0002\u025d\u026e\u0007$\u0002\u0002\u025e\u025f",
    "\u0007)\u0002\u0002\u025f\u0260\u0007)\u0002\u0002\u0260\u0261\u0007",
    ")\u0002\u0002\u0261\u0267\u0003\u0002\u0002\u0002\u0262\u0263\u0007",
    "^\u0002\u0002\u0263\u0266\u000b\u0002\u0002\u0002\u0264\u0266\n\u0014",
    "\u0002\u0002\u0265\u0262\u0003\u0002\u0002\u0002\u0265\u0264\u0003\u0002",
    "\u0002\u0002\u0266\u0269\u0003\u0002\u0002\u0002\u0267\u0268\u0003\u0002",
    "\u0002\u0002\u0267\u0265\u0003\u0002\u0002\u0002\u0268\u026a\u0003\u0002",
    "\u0002\u0002\u0269\u0267\u0003\u0002\u0002\u0002\u026a\u026b\u0007)",
    "\u0002\u0002\u026b\u026c\u0007)\u0002\u0002\u026c\u026e\u0007)\u0002",
    "\u0002\u026d\u0221\u0003\u0002\u0002\u0002\u026d\u0238\u0003\u0002\u0002",
    "\u0002\u026d\u024f\u0003\u0002\u0002\u0002\u026d\u025e\u0003\u0002\u0002",
    "\u0002\u026e\u0092\u0003\u0002\u0002\u0002\u026f\u0271\u0007\u000f\u0002",
    "\u0002\u0270\u026f\u0003\u0002\u0002\u0002\u0270\u0271\u0003\u0002\u0002",
    "\u0002\u0271\u0272\u0003\u0002\u0002\u0002\u0272\u0274\u0007\f\u0002",
    "\u0002\u0273\u0270\u0003\u0002\u0002\u0002\u0274\u0275\u0003\u0002\u0002",
    "\u0002\u0275\u0273\u0003\u0002\u0002\u0002\u0275\u0276\u0003\u0002\u0002",
    "\u0002\u0276\u0277\u0003\u0002\u0002\u0002\u0277\u0286\bJ\u0002\u0002",
    "\u0278\u027c\u0007^\u0002\u0002\u0279\u027b\t\u0011\u0002\u0002\u027a",
    "\u0279\u0003\u0002\u0002\u0002\u027b\u027e\u0003\u0002\u0002\u0002\u027c",
    "\u027a\u0003\u0002\u0002\u0002\u027c\u027d\u0003\u0002\u0002\u0002\u027d",
    "\u0280\u0003\u0002\u0002\u0002\u027e\u027c\u0003\u0002\u0002\u0002\u027f",
    "\u0281\u0007\u000f\u0002\u0002\u0280\u027f\u0003\u0002\u0002\u0002\u0280",
    "\u0281\u0003\u0002\u0002\u0002\u0281\u0282\u0003\u0002\u0002\u0002\u0282",
    "\u0283\u0007\f\u0002\u0002\u0283\u0284\u0003\u0002\u0002\u0002\u0284",
    "\u0286\bJ\u0003\u0002\u0285\u0273\u0003\u0002\u0002\u0002\u0285\u0278",
    "\u0003\u0002\u0002\u0002\u0286\u0287\u0003\u0002\u0002\u0002\u0287\u0288",
    "\bJ\u0004\u0002\u0288\u0289\u0003\u0002\u0002\u0002\u0289\u028a\bJ\u0005",
    "\u0002\u028a\u0094\u0003\u0002\u0002\u0002\u028b\u028d\t\u0011\u0002",
    "\u0002\u028c\u028b\u0003\u0002\u0002\u0002\u028d\u028e\u0003\u0002\u0002",
    "\u0002\u028e\u028c\u0003\u0002\u0002\u0002\u028e\u028f\u0003\u0002\u0002",
    "\u0002\u028f\u0290\u0003\u0002\u0002\u0002\u0290\u0291\bK\u0006\u0002",
    "\u0291\u0292\u0003\u0002\u0002\u0002\u0292\u0293\bK\u0005\u0002\u0293",
    "\u0096\u0003\u0002\u0002\u0002\u0294\u0298\u0007%\u0002\u0002\u0295",
    "\u0297\n\u0015\u0002\u0002\u0296\u0295\u0003\u0002\u0002\u0002\u0297",
    "\u029a\u0003\u0002\u0002\u0002\u0298\u0296\u0003\u0002\u0002\u0002\u0298",
    "\u0299\u0003\u0002\u0002\u0002\u0299\u029b\u0003\u0002\u0002\u0002\u029a",
    "\u0298\u0003\u0002\u0002\u0002\u029b\u029c\bL\u0007\u0002\u029c\u0098",
    "\u0003\u0002\u0002\u0002\u029d\u029e\u0007*\u0002\u0002\u029e\u029f",
    "\bM\b\u0002\u029f\u009a\u0003\u0002\u0002\u0002\u02a0\u02a1\u0007+\u0002",
    "\u0002\u02a1\u02a2\bN\t\u0002\u02a2\u009c\u0003\u0002\u0002\u0002\u02a3",
    "\u02a4\u0007}\u0002\u0002\u02a4\u02a5\bO\n\u0002\u02a5\u009e\u0003\u0002",
    "\u0002\u0002\u02a6\u02a7\u0007\u007f\u0002\u0002\u02a7\u02a8\bP\u000b",
    "\u0002\u02a8\u00a0\u0003\u0002\u0002\u0002\u02a9\u02aa\u0007]\u0002",
    "\u0002\u02aa\u02ab\bQ\f\u0002\u02ab\u00a2\u0003\u0002\u0002\u0002\u02ac",
    "\u02ad\u0007_\u0002\u0002\u02ad\u02ae\bR\r\u0002\u02ae\u00a4\u0003\u0002",
    "\u0002\u0002\u02af\u02b0\u000b\u0002\u0002\u0002\u02b0\u02b1\u0003\u0002",
    "\u0002\u0002\u02b1\u02b2\bS\u0007\u0002\u02b2\u00a6\u0003\u0002\u0002",
    "\u00028\u0002\u01b0\u01b8\u01bd\u01c2\u01c4\u01ca\u01cd\u01d3\u01d6",
    "\u01d8\u01dd\u01e3\u01ea\u01ec\u01f0\u01f5\u01f7\u01fa\u01ff\u0204\u0209",
    "\u020c\u020f\u0211\u0214\u0217\u021a\u021d\u021f\u0226\u0229\u022c\u022f",
    "\u0232\u0234\u023d\u0240\u0243\u0246\u0249\u024b\u0256\u0258\u0265\u0267",
    "\u026d\u0270\u0275\u027c\u0280\u0285\u028e\u0298\u000e\u0003J\u0002",
    "\u0003J\u0003\u0003J\u0004\u0002\u0003\u0002\u0003K\u0005\b\u0002\u0002",
    "\u0003M\u0006\u0003N\u0007\u0003O\b\u0003P\t\u0003Q\n\u0003R\u000b"].join("");


var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map( function(ds, index) { return new antlr4.dfa.DFA(ds, index); });

function Python2Lexer(input) {
	antlr4.Lexer.call(this, input);
    this._interp = new antlr4.atn.LexerATNSimulator(this, atn, decisionsToDFA, new antlr4.PredictionContextCache());
    return this;
}

Python2Lexer.prototype = Object.create(antlr4.Lexer.prototype);
Python2Lexer.prototype.constructor = Python2Lexer;

Object.defineProperty(Python2Lexer.prototype, "atn", {
        get : function() {
                return atn;
        }
});

Python2Lexer.EOF = antlr4.Token.EOF;
Python2Lexer.T__0 = 1;
Python2Lexer.T__1 = 2;
Python2Lexer.T__2 = 3;
Python2Lexer.T__3 = 4;
Python2Lexer.T__4 = 5;
Python2Lexer.T__5 = 6;
Python2Lexer.T__6 = 7;
Python2Lexer.T__7 = 8;
Python2Lexer.T__8 = 9;
Python2Lexer.T__9 = 10;
Python2Lexer.T__10 = 11;
Python2Lexer.T__11 = 12;
Python2Lexer.T__12 = 13;
Python2Lexer.T__13 = 14;
Python2Lexer.T__14 = 15;
Python2Lexer.T__15 = 16;
Python2Lexer.T__16 = 17;
Python2Lexer.T__17 = 18;
Python2Lexer.T__18 = 19;
Python2Lexer.T__19 = 20;
Python2Lexer.T__20 = 21;
Python2Lexer.T__21 = 22;
Python2Lexer.T__22 = 23;
Python2Lexer.T__23 = 24;
Python2Lexer.T__24 = 25;
Python2Lexer.T__25 = 26;
Python2Lexer.T__26 = 27;
Python2Lexer.T__27 = 28;
Python2Lexer.T__28 = 29;
Python2Lexer.T__29 = 30;
Python2Lexer.T__30 = 31;
Python2Lexer.T__31 = 32;
Python2Lexer.T__32 = 33;
Python2Lexer.T__33 = 34;
Python2Lexer.T__34 = 35;
Python2Lexer.T__35 = 36;
Python2Lexer.T__36 = 37;
Python2Lexer.T__37 = 38;
Python2Lexer.T__38 = 39;
Python2Lexer.T__39 = 40;
Python2Lexer.T__40 = 41;
Python2Lexer.T__41 = 42;
Python2Lexer.T__42 = 43;
Python2Lexer.T__43 = 44;
Python2Lexer.T__44 = 45;
Python2Lexer.T__45 = 46;
Python2Lexer.T__46 = 47;
Python2Lexer.T__47 = 48;
Python2Lexer.T__48 = 49;
Python2Lexer.T__49 = 50;
Python2Lexer.T__50 = 51;
Python2Lexer.T__51 = 52;
Python2Lexer.T__52 = 53;
Python2Lexer.T__53 = 54;
Python2Lexer.T__54 = 55;
Python2Lexer.T__55 = 56;
Python2Lexer.T__56 = 57;
Python2Lexer.T__57 = 58;
Python2Lexer.T__58 = 59;
Python2Lexer.T__59 = 60;
Python2Lexer.T__60 = 61;
Python2Lexer.T__61 = 62;
Python2Lexer.T__62 = 63;
Python2Lexer.T__63 = 64;
Python2Lexer.T__64 = 65;
Python2Lexer.T__65 = 66;
Python2Lexer.T__66 = 67;
Python2Lexer.T__67 = 68;
Python2Lexer.T__68 = 69;
Python2Lexer.NAME = 70;
Python2Lexer.NUMBER = 71;
Python2Lexer.STRING = 72;
Python2Lexer.LINENDING = 73;
Python2Lexer.WHITESPACE = 74;
Python2Lexer.COMMENT = 75;
Python2Lexer.OPEN_PAREN = 76;
Python2Lexer.CLOSE_PAREN = 77;
Python2Lexer.OPEN_BRACE = 78;
Python2Lexer.CLOSE_BRACE = 79;
Python2Lexer.OPEN_BRACKET = 80;
Python2Lexer.CLOSE_BRACKET = 81;
Python2Lexer.UNKNOWN = 82;

Python2Lexer.prototype.channelNames = [ "DEFAULT_TOKEN_CHANNEL", "HIDDEN" ];

Python2Lexer.prototype.modeNames = [ "DEFAULT_MODE" ];

Python2Lexer.prototype.literalNames = [ null, "'@'", "'def'", "':'", "'='", 
                                        "','", "'*'", "'**'", "';'", "'+='", 
                                        "'-='", "'*='", "'/='", "'%='", 
                                        "'&='", "'|='", "'^='", "'<<='", 
                                        "'>>='", "'**='", "'//='", "'>>'", 
                                        "'del'", "'pass'", "'break'", "'continue'", 
                                        "'return'", "'raise'", "'import'", 
                                        "'from'", "'.'", "'as'", "'global'", 
                                        "'exec'", "'in'", "'assert'", "'if'", 
                                        "'elif'", "'else'", "'while'", "'for'", 
                                        "'try'", "'finally'", "'with'", 
                                        "'except'", "'lambda'", "'or'", 
                                        "'and'", "'not'", "'<'", "'>'", 
                                        "'=='", "'>='", "'<='", "'<>'", 
                                        "'!='", "'is'", "'|'", "'^'", "'&'", 
                                        "'<<'", "'+'", "'-'", "'/'", "'%'", 
                                        "'//'", "'~'", "'`'", "'class'", 
                                        "'yield'", null, null, null, null, 
                                        null, null, "'('", "')'", "'{'", 
                                        "'}'", "'['", "']'" ];

Python2Lexer.prototype.symbolicNames = [ null, null, null, null, null, null, 
                                         null, null, null, null, null, null, 
                                         null, null, null, null, null, null, 
                                         null, null, null, null, null, null, 
                                         null, null, null, null, null, null, 
                                         null, null, null, null, null, null, 
                                         null, null, null, null, null, null, 
                                         null, null, null, null, null, null, 
                                         null, null, null, null, null, null, 
                                         null, null, null, null, null, null, 
                                         null, null, null, null, null, null, 
                                         null, null, null, null, "NAME", 
                                         "NUMBER", "STRING", "LINENDING", 
                                         "WHITESPACE", "COMMENT", "OPEN_PAREN", 
                                         "CLOSE_PAREN", "OPEN_BRACE", "CLOSE_BRACE", 
                                         "OPEN_BRACKET", "CLOSE_BRACKET", 
                                         "UNKNOWN" ];

Python2Lexer.prototype.ruleNames = [ "T__0", "T__1", "T__2", "T__3", "T__4", 
                                     "T__5", "T__6", "T__7", "T__8", "T__9", 
                                     "T__10", "T__11", "T__12", "T__13", 
                                     "T__14", "T__15", "T__16", "T__17", 
                                     "T__18", "T__19", "T__20", "T__21", 
                                     "T__22", "T__23", "T__24", "T__25", 
                                     "T__26", "T__27", "T__28", "T__29", 
                                     "T__30", "T__31", "T__32", "T__33", 
                                     "T__34", "T__35", "T__36", "T__37", 
                                     "T__38", "T__39", "T__40", "T__41", 
                                     "T__42", "T__43", "T__44", "T__45", 
                                     "T__46", "T__47", "T__48", "T__49", 
                                     "T__50", "T__51", "T__52", "T__53", 
                                     "T__54", "T__55", "T__56", "T__57", 
                                     "T__58", "T__59", "T__60", "T__61", 
                                     "T__62", "T__63", "T__64", "T__65", 
                                     "T__66", "T__67", "T__68", "NAME", 
                                     "NUMBER", "STRING", "LINENDING", "WHITESPACE", 
                                     "COMMENT", "OPEN_PAREN", "CLOSE_PAREN", 
                                     "OPEN_BRACE", "CLOSE_BRACE", "OPEN_BRACKET", 
                                     "CLOSE_BRACKET", "UNKNOWN" ];

Python2Lexer.prototype.grammarFileName = "Python2.g4";


var old_lexer = Python2Lexer;
Python2Lexer = function() {
    old_lexer.apply(this, arguments);
    this._openBRCount       = 0
    this._suppressNewlines  = false
    this._lineContinuation  = false
    this._tokens            = new TokenQueue();
    this._indents           = new IndentStack();
    antlr4.Lexer.prototype.reset.call(this);
}

Python2Lexer.prototype = Object.create(old_lexer.prototype);
Python2Lexer.prototype.constructor = Python2Lexer;

Python2Lexer.prototype.nextToken = function() {
    if (!this._tokens.empty()) {
        return this._tokens.deq();
    } else {
        var t = antlr4.Lexer.prototype.nextToken.call(this);
        if (t.type !== Python2Parser.EOF) return t;
        else {
            if (!this._suppressNewlines) {
                this.emitNewline();
            }
            this.emitFullDedent();
            this.emitEndmarker();
            this.emitEndToken(t);
            return this._tokens.deq();
        }
    }

}

Python2Lexer.prototype.emitEndToken = function (token) {
    this._tokens.enq(token);
}

Python2Lexer.prototype.emitIndent = function (length = 0, text = 'INDENT') {
    var t = this.createToken(Python2Parser.INDENT, text, length);
    this._tokens.enq(t);
}

Python2Lexer.prototype.emitDedent = function () {
    var t = this.createToken(Python2Parser.DEDENT, 'DEDENT');
    this._tokens.enq(t);
}

Python2Lexer.prototype.emitFullDedent = function () {
    while (!this._indents.empty()) {
        this._indents.pop();
        this.emitDedent();
    }
}

Python2Lexer.prototype.emitEndmarker = function () {
    var t = this.createToken(Python2Parser.ENDMARKER, 'ENDMARKER');
    this._tokens.enq(t);
}

Python2Lexer.prototype.emitNewline = function () {
    var t = this.createToken(Python2Parser.NEWLINE, 'NEWLINE');
    this._tokens.enq(t);
}

Python2Lexer.prototype.createToken = function (type_, text="", length=0) {
    var start = this._tokenStartCharIndex;
    var stop = start + length;
    var t = new CommonToken(this._tokenFactorySourcePair,
            type_, this.DEFAULT_TOKEN_CHANNEL,
            start, stop);
    t.text = text;
    return t;
}


Python2Lexer.prototype.action = function(localctx, ruleIndex, actionIndex) {
	switch (ruleIndex) {
	case 72:
		this.LINENDING_action(localctx, actionIndex);
		break;
	case 73:
		this.WHITESPACE_action(localctx, actionIndex);
		break;
	case 75:
		this.OPEN_PAREN_action(localctx, actionIndex);
		break;
	case 76:
		this.CLOSE_PAREN_action(localctx, actionIndex);
		break;
	case 77:
		this.OPEN_BRACE_action(localctx, actionIndex);
		break;
	case 78:
		this.CLOSE_BRACE_action(localctx, actionIndex);
		break;
	case 79:
		this.OPEN_BRACKET_action(localctx, actionIndex);
		break;
	case 80:
		this.CLOSE_BRACKET_action(localctx, actionIndex);
		break;
	default:
		throw "No registered action for:" + ruleIndex;
	}
};

Python2Lexer.prototype.LINENDING_action = function(localctx , actionIndex) {
	switch (actionIndex) {
	case 0:
		this._lineContinuation=false
		break;
	case 1:
		this._lineContinuation=true
		break;
	case 2:

		if (this._openBRCount == 0 && !this._lineContinuation) {
		    if (!this._suppressNewlines) {
		        this.emitNewline()
		        this._suppressNewlines = true
		    }
		    var la = this._input.LA(1)
		    if ([ord(' '), ord('\t'), ord('#')].indexOf(la) === -1) {
		        this._suppressNewlines = false
		        this.emitFullDedent()
		    }
		}

		break;
	default:
		throw "No registered action for:" + actionIndex;
	}
};

Python2Lexer.prototype.WHITESPACE_action = function(localctx , actionIndex) {
	switch (actionIndex) {
	case 3:

		if (this._tokenStartColumn == 0 && this._openBRCount == 0
		    && !this._lineContinuation) {

		    var la = this._input.LA(1);
		    if ([ord('\r'), ord('\n'), ord('#'), -1].indexOf(la)===-1)
		        this._suppressNewlines = false
		        var wsCount = 0;
		        for (var ch in this.text) {
		            ch = this.text[ch];
		            if (ch == ' ') wsCount += 1
		            else if (ch == '\t') wsCount += 8
		        }

		        if (wsCount > this._indents.wsval()) {
		            this.emitIndent(this.text.length)
		            this._indents.push(wsCount)
		        }
		        else {
		            while (wsCount < this._indents.wsval()) {
		                this.emitDedent()
		                this._indents.pop()
		            }
		            if (wsCount != this._indents.wsval()) {
		                // throw new Error('wsCount')
		            }
		        }
		    }

		break;
	default:
		throw "No registered action for:" + actionIndex;
	}
};

Python2Lexer.prototype.OPEN_PAREN_action = function(localctx , actionIndex) {
	switch (actionIndex) {
	case 4:
		this._openBRCount  += 1
		break;
	default:
		throw "No registered action for:" + actionIndex;
	}
};

Python2Lexer.prototype.CLOSE_PAREN_action = function(localctx , actionIndex) {
	switch (actionIndex) {
	case 5:
		this._openBRCount  -= 1
		break;
	default:
		throw "No registered action for:" + actionIndex;
	}
};

Python2Lexer.prototype.OPEN_BRACE_action = function(localctx , actionIndex) {
	switch (actionIndex) {
	case 6:
		this._openBRCount  += 1
		break;
	default:
		throw "No registered action for:" + actionIndex;
	}
};

Python2Lexer.prototype.CLOSE_BRACE_action = function(localctx , actionIndex) {
	switch (actionIndex) {
	case 7:
		this._openBRCount  -= 1
		break;
	default:
		throw "No registered action for:" + actionIndex;
	}
};

Python2Lexer.prototype.OPEN_BRACKET_action = function(localctx , actionIndex) {
	switch (actionIndex) {
	case 8:
		this._openBRCount  += 1
		break;
	default:
		throw "No registered action for:" + actionIndex;
	}
};

Python2Lexer.prototype.CLOSE_BRACKET_action = function(localctx , actionIndex) {
	switch (actionIndex) {
	case 9:
		this._openBRCount  -= 1
		break;
	default:
		throw "No registered action for:" + actionIndex;
	}
};


export { Python2Lexer };

